import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import DataController from 'components/DataController/DataController';
import { IItemVideoStudio } from 'types';
import { VideoStudiosContext, IVideoStudiosContext } from '../../../videoStudiosState/videoStudiosContext';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemVideoStudio;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForDeletion, setIDForEdit } = useContext<IVideoStudiosContext>(VideoStudiosContext);

	const nameRowClasses = classNames(style.row, style.name);
	const actionRowClasses = classNames(style.row, style.action);

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	const handleEdit = () => {
		setIDForEdit(data.id);
	};

	return (
		<div data-test={`Item-${index}`} className={style.container}>
			<Text className={nameRowClasses} translationKey={data.name} withTooltip={true} />
			<div className={actionRowClasses}>
				<DataController onClickDelete={handleSetIdForDeletion} onClickEdit={handleEdit} size="smallBtn" />
			</div>
		</div>
	);
};

export default Item;
